import React, { useState, memo } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const previewImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/mkJheY745XY1bHCKGedij2/Captura_de_pantalla_2026-02-05_a_las_1.52.18_p._m..png',
  alt: 'Dibujo Narrativo de 100 Viñetas - Actividad para 14-18 años'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nk81Q216sgNNzoW2kurLPs/Captura_de_pantalla_2026-02-05_a_las_1.52.03_p._m..png',
  alt: 'Pintura Expresiva Profunda - Bloque 2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4CWycrxHxsBCVQo9tynrRi/Captura_de_pantalla_2026-02-05_a_las_1.42.35_p._m..png',
  alt: 'Dibujo de memoria progresivo - Actividad para 8-12 años'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oLnzteMK2jnDV8AcduuxS8/Captura_de_pantalla_2026-02-05_a_las_1.42.25_p._m..png',
  alt: 'Dibujo Experimental y Conceptual - Bloque 1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uwL1faDC5aWhkXicwNHYGq/Captura_de_pantalla_2026-02-05_a_las_1.42.13_p._m..png',
  alt: 'Juego de Dibujo por Turnos - Bloque 5'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uRMFcNRGoP7WXPsV6yTjX5/Captura_de_pantalla_2026-02-05_a_las_1.41.42_p._m..png',
  alt: 'Dibujo de Objetos Imaginarios - Bloque 1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jBYB1yVSm97t3yEJzW5QSS/Captura_de_pantalla_2026-02-05_a_las_1.41.26_p._m..png',
  alt: 'Bienvenidos al Mega Pack Arte - Lista 2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8zXMMVdK3Hpzwj3YusP7pB/Captura_de_pantalla_2026-02-05_a_las_1.41.14_p._m..png',
  alt: 'Actividad 4: Dibujo con la mano no dominante'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5jv1oLghiedtwtQXrVDK9u/Captura_de_pantalla_2026-02-05_a_las_1.41.05_p._m..png',
  alt: 'Beneficios para el docente'
}];
export function PreviewCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    setCurrentIndex(prev => prev === 0 ? previewImages.length - 1 : prev - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prev => prev === previewImages.length - 1 ? 0 : prev + 1);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <section className="py-20 px-4 bg-slate-50" data-id="element-259">
      <div className="max-w-4xl mx-auto" data-id="element-260">
        <div className="text-center mb-12" data-id="element-261">
          <span className="text-blue-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-262">
            👀 Mirá por dentro
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-4" data-id="element-263">
            Así es el material por dentro
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-264">
            Actividades reales, listas para usar en tu próxima clase
          </p>
        </div>

        {/* Carousel Container */}
        <div className="relative" data-id="element-265">
          {/* Main Image */}
          <div className="relative overflow-hidden rounded-2xl bg-white shadow-lg border border-slate-200" data-id="element-266">
            <div className="relative" data-id="element-267">
              {previewImages.map((image, index) => <div key={index} className={`transition-opacity duration-500 ease-in-out ${currentIndex === index ? 'opacity-100 relative' : 'opacity-0 absolute inset-0 pointer-events-none'}`} data-id="element-268">
                  <img src={image.src} alt={image.alt} className="w-full h-auto bg-white" data-id="element-269" />
                </div>)}
            </div>

            {/* Navigation Arrows */}
            <button onClick={goToPrevious} className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/90 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center hover:bg-white transition-colors border border-slate-200" aria-label="Imagen anterior" data-id="element-270">
              <ChevronLeft className="w-5 h-5 md:w-6 md:h-6 text-slate-700" data-id="element-271" />
            </button>
            <button onClick={goToNext} className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/90 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center hover:bg-white transition-colors border border-slate-200" aria-label="Imagen siguiente" data-id="element-272">
              <ChevronRight className="w-5 h-5 md:w-6 md:h-6 text-slate-700" data-id="element-273" />
            </button>

            {/* Counter Badge */}
            <div className="absolute top-4 right-4 bg-slate-900/70 backdrop-blur-sm text-white text-xs font-bold px-3 py-1.5 rounded-full" data-id="element-274">
              {currentIndex + 1} / {previewImages.length}
            </div>
          </div>

          {/* Dots Navigation */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-275">
            {previewImages.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`transition-all duration-300 rounded-full ${currentIndex === index ? 'w-8 h-3 bg-blue-600' : 'w-3 h-3 bg-slate-300 hover:bg-slate-400'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-276" />)}
          </div>

          {/* Thumbnail Strip */}
          <div className="flex justify-center gap-2 mt-6 overflow-x-auto pb-2 px-2" data-id="element-277">
            {previewImages.map((image, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-14 h-14 md:w-16 md:h-16 rounded-lg overflow-hidden border-2 transition-all duration-300 flex-shrink-0 ${currentIndex === index ? 'border-blue-600 shadow-md scale-105' : 'border-slate-200 opacity-60 hover:opacity-100'}`} data-id="element-278">
                <img src={image.src} alt={image.alt} className="w-full h-full object-cover" data-id="element-279" />
              </button>)}
          </div>
        </div>
      </div>
    </section>;
}